import React from 'react';
import { type i18nLabel } from '../../types';
import { FormattedMessage } from 'react-intl-next';
import { type SwitcherItemType } from '../utils/links';

type ProductConfigurationApiBase = {
	description: string | i18nLabel | null;
	href: string;
	key: string;
	label: string | i18nLabel;
	ordinal: number;
};

export const formatLabel = (
	label: ProductConfigurationApiBase['label'],
): SwitcherItemType['label'] => {
	return typeof label === 'string' ? label : <FormattedMessage {...label} />;
};

export const formatDescription = (
	description: ProductConfigurationApiBase['description'],
): SwitcherItemType['description'] => {
	return typeof description === 'string' ? (
		description
	) : description ? (
		<FormattedMessage {...description} />
	) : null;
};
